// User preference for v1 (classic) vs v2 (Co-Scientist) UI, on cells where v2
// is the default (withV2). "v1" = user explicitly chose the classic UI.
const KEY = "plexUI";

export const prefersClassicUI = () => {
  try { return localStorage.getItem(KEY) === "v1"; } catch (_) { return false; }
};
export const chooseClassicUI = () => {
  try { localStorage.setItem(KEY, "v1"); } catch (_) { /* ignore */ }
};
export const chooseModernUI = () => {
  try { localStorage.removeItem(KEY); } catch (_) { /* ignore */ }
};
